import {Locales} from '@netx/core-next/locales/utils/Locales';

export const SystemPeopleTitle = Locales((i18n) => ({
	IDENTIFIED: i18n('i18n.identified'),
	UNIDENTIFIED: i18n('i18n.unidentified'),
	HIDDEN: i18n('i18n.hidden'),
	PEOPLE: i18n('i18n.people'),

	IDENTIFY_PERSON: i18n('i18n.identifyPerson'),

	CONFIRM_HIDE: i18n('i18n.hidePerson'),
	CONFIRM_UNIDENTIFY: i18n('i18n.unidentifyPerson'),
	CONFIRM_BULK_HIDE: i18n('i18n.hidePeople'),
	CONFIRM_BULK_UNIDENTIFY: i18n('i18n.unidentifyPeople'),
}));

export const SystemPeopleLabel = Locales((i18n) => ({
	PEOPLE: i18n('i18n.people'),
}));

export const SystemPeopleSubTitle = Locales((i18n) => ({
	TOTAL: (count: number) => i18n('i18n.nItems', {count}),
}));

export const SystemPeopleActionLabel = Locales((i18n) => ({
	DELETE: i18n('i18n.delete'),
	EDIT: i18n('i18n.rename'),
	HIDE: i18n('i18n.hide'),
	MERGE: i18n('i18n.merge'),
	IDENTIFY: i18n('i18n.identify'),
	UNIDENTIFY: i18n('i18n.unidentify'),
	UNHIDE: i18n('i18n.movePersonToUnidentified'),
	DELETE_NAME: i18n('i18n.deletePersonName'),
	SEARCH_VALUES: (count: number) => i18n('i18n.viewAssets'),
}));

export const SystemPeopleMessage = Locales((i18n) => ({
	ERROR: i18n('i18n.errorRequestFailed'),
	NO_RECORDS: i18n('i18n.noPeopleYet'),
	NO_MATCHING_RECORDS: i18n('i18n.noMatches'),

	CONFIRM_HIDE: (name: string) => i18n('i18n.confirmHidePerson', {name}),
	CONFIRM_IDENTIFY_HIDDEN: i18n('i18n.confirmIdentifyHiddenPerson'),
	CONFIRM_UNIDENTIFY: (name: string) =>
		i18n('i18n.confirmUnidentifyPerson', {name}),
	CONFIRM_BULK_HIDE: (count: number) =>
		i18n('i18n.confirmBulkHidePeople', {count}),
	CONFIRM_BULK_UNIDENTIFY: (count: number) =>
		i18n('i18n.confirmBulkUnidentifyPeople', {count}),
}));

export const SystemPeopleColumnLabel = Locales((i18n) => ({
	name: i18n('i18n.name'),
	assetCount: i18n('i18n.assets'),
	modificationDate: i18n('i18n.lastModified'),
}));
